export * from './cn';

// import { toast } from 'sonner';
interface ApplicationError extends Error {
    info: string;
    status: number;
}

export const createFetcher = (token?: string, method?: string) => {
    return async (url: string, hideError?: boolean) => {
        const res = await fetch(url, {
            method,
            headers: {
                Authorization: `Bearer ${token}`,
                'x-mastra-dev-playground': 'false',
            },
        });

        if (!res.ok) {
            const error = new Error('An error occurred while fetching the data.') as ApplicationError;

            error.info = await res.json();
            error.status = res.status;

            if (!hideError) {
                // toast.error((error?.info as any)?.error || error?.message);
                console.error((error?.info as any)?.error || error?.message);
            }

            throw error;
        }

        return res.json();
    };
};
